import { render, staticRenderFns } from "./item-preview.vue?vue&type=template&id=26dc858f&"
import script from "./item-preview.vue?vue&type=script&lang=ts&"
export * from "./item-preview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports